export { VpAutoSave } from './VpAutoSave';



// WEBPACK FOOTER //
// ./src/vp-ui/components/VpAutoSave/index.js